import script from "./PotokTelegramApp.vue?vue&type=script&setup=true&lang=js"
export * from "./PotokTelegramApp.vue?vue&type=script&setup=true&lang=js"

import "./PotokTelegramApp.vue?vue&type=style&index=0&id=ac8c4ece&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac8c4ece"]])

export default __exports__